import React, {Component} from 'react'
import CriteriaRow from './criteria_row'


export default class CollectionCriteria extends Component {
  constructor(props){
    super(props);

    this.state = { criteria: this.props.data, status: "", loading: false, product_collections: [], tags: [], brands: []};

    this.rowChange = this.rowChange.bind(this);
    this.rowAdd = this.rowAdd.bind(this);
    this.rowRemove = this.rowRemove.bind(this);
    this.logicalChange = this.logicalChange.bind(this);
    this.save = this.save.bind(this);
    this.reloadTags = this.reloadTags.bind(this);
    this.reloadBrands = this.reloadBrands.bind(this);

    this.reloadProductCollections = this.reloadProductCollections.bind(this);
    this.Status= this.Status.bind(this);
    this.clearState = this.clearState.bind(this);
     }

  componentDidMount() {
    this.reloadTags();
    this.reloadProductCollections();
    this.reloadBrands();
  }

  rowChange(row){
    var c = this.state.criteria;
    var where = c.wheres.find(function (r){ return r.key == row.key});
    where = row
    this.setState({criteria: c});
  }

  rowRemove(row){
    var c = this.state.criteria;
    var where = c.wheres.filter(function (r){ return r.key != row.key});
    c.wheres = where
    this.setState({criteria: c});
  }

  rowAdd(){
   let c = this.state.criteria;
    var next_key = c.wheres.length + 1000;
    c.wheres.push({field:"", operator:"equals", value:"", key: next_key});
    this.setState({criteria: c});
  }

  logicalChange(event){
    var c = this.state.criteria;
    c.logical_operator = event.target.value;
    this.setState({criteria: c});
  }

  Status(){
  //return <p>{this.state.status}</p>;
   if (this.state.status === 201){
    return (<div className="alert-success text-center" style={{padding: "10px"}}>
        <button className='close'
          onClick={this.clearState}> &times; </button> Success!
          </div>

          );
   }
   else if (this.state.status > 400){
    return (<div className="alert-danger text-center" style={{padding: "10px"}}>
        <button className='close'
          onClick={this.clearState}> &times; </button> Something Went Wrong
          </div>
          );
  }
   
  }

 
  loading(){
    if (this.state.loading){
      return "Loading...";
    }
    else {
      return "Save";
    }
  }

  clearState(){
    this.setState({status: ""});
  }

  reloadTags(){
    var t = this;
    $.ajax({
      method: 'GET',
      url: Routes.rmrc_ad_all_tags_path(),
      dataType: 'JSON',
      success: function(data){
      t.setState({ tags: data["tags"] }); 
      }
    });

    return t.state.tags;
  }


  reloadBrands(){
    var t = this;
    $.ajax({
      method: 'GET',
      url: Routes.rmrc_ad_all_brands_path(),
      dataType: 'JSON',
      success: function(data){
      t.setState({ brands: data["brands"] }); 
      }
    });

    return t.state.brands;
  }

  reloadProductCollections(){
     var t = this;
    $.ajax({
      method: 'GET',
      url: Routes.rmrc_ad_all_product_collections_path(),
      dataType: 'JSON',
      success: function(data){

      t.setState({ product_collections: data["product_collections"] }); 
      }
    });

    return t.state.product_collections;
  }

  save(event){
    var t = this;
    var url = Routes[t.props.update_route]({id: t.props.model_id});
    this.setState({loading: true});
    $.ajax({
      method: 'POST',
      url: url,
      dataType: 'JSON',
      data: t.state.criteria,
      success: function(data, statusText, xhr){
        t.setState({loading: false});
        
        t.setState({status: xhr.status }); 

      },
      error: function(data, statusText, xhr){
        t.setState({loading: false});
        t.setState({status: data.status }); 

      }
    });
  }

  render() {
    var t = this;
    var rows = this.state.criteria.wheres.map(function (m){
      return (
        <CriteriaRow data={m} key={m.key} updateRow={t.rowChange} 
        brands={t.state.brands}
        removeRow={t.rowRemove} criteriaFields={t.props.criteria_fields}  tags={t.state.tags} product_collections={t.state.product_collections}
        reload_product_collections={t.reloadProductCollections}
        reload_tags={t.reloadTags} reload_brands={t.reloadBrands} />
      );
    });

    return (
      <div>
      <div>
      {this.Status()}
      <label>
      <input type="radio" name="logical_operator" value="or" checked={t.state.criteria.logical_operator == "or"} onChange={t.logicalChange}></input> Matches <strong>Any</strong> of these</label>

      <label style={{marginLeft: "100px" }}>
      <input type="radio" name="logical_operator" value="and" checked={t.state.criteria.logical_operator == "and"} onChange={t.logicalChange}></input> Matches <strong>All</strong> of these</label>
      </div>
      <table className="table">
      <thead>
      <tr>
      <th style={{ width: "175px"}} >
      Field
      </th>
      <th style={{ width: "250px"}} >
      Operator
      </th>
      <th>
      Value
      </th>
      <th style={{width: "70px"}} >
      Actions
      </th>
      </tr>
      </thead>
      <tbody>
      {rows}
      </tbody>
      <tfoot>
      <tr>
      <td><button className="btn btn-info" onClick={t.rowAdd} ><i className="glyphicon glyphicon-plus"></i></button></td>
      <td></td>
      <td></td>
      <td>
      <button className="btn btn-success" disabled={this.state.loading} onClick={t.save}>{this.loading()}</button>
      </td>
      </tr>
      </tfoot>
      </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/components/collection_criteria.jsx